import React, { useEffect, useState } from "react";
import clsx from "classnames";
import { useStyles } from "./ScrollWrapper.style";

interface ScrollWrapperProps {
  children: React.ReactNode;
  isTabs?: boolean;
}

const ScrollWrapper: React.FC<ScrollWrapperProps> = ({ children, isTabs }) => {
  const classes = useStyles();

  const [isHidden, setIsHidden] = useState(false);
  const [isActiveBackdropFilter, setIsActiveBackdropFilter] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY === 0) {
        //keep header on top
        setIsHidden(false);
        setIsActiveBackdropFilter(false);
      }
      //just when scroll up to hide header
      else if (currentScrollY > lastScrollY) {
        setIsHidden(true);
        if (timeoutId) clearTimeout(timeoutId); // Clear old timeout

        //add backdrop filter header after 300s
        const newTimeoutId = setTimeout(() => {
          setIsActiveBackdropFilter(true);
          setIsHidden(false);
        }, 300);

        setTimeoutId(newTimeoutId);
      } else {
        setIsHidden(false);
        setIsActiveBackdropFilter(true);
      }

      setLastScrollY(currentScrollY);
    };

    window?.addEventListener("scroll", handleScroll);

    return () => {
      window?.removeEventListener("scroll", handleScroll);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [lastScrollY, timeoutId]);

  return (
    <div
      className={classes.root}
      style={{
        transform: isHidden ? "translateY(-100%)" : "translateY(0)",
        height: !isTabs ? 70 : "",
      }}
    >
      <div
        className={clsx(
          classes.backdropFilter,
          isActiveBackdropFilter ? classes.show : classes.hide,
        )}
      />
      {children}
    </div>
  );
};

export default ScrollWrapper;
